export function toRadians(degrees) {
  return (degrees * Math.PI) / 180;
}

export function distanceInMeters(pointA, pointB) {
  if (!pointA || !pointB) return Infinity;

  const lat1 = Number(pointA.latitude ?? pointA.lat);
  const lon1 = Number(pointA.longitude ?? pointA.lng ?? pointA.lon);
  const lat2 = Number(pointB.latitude ?? pointB.lat);
  const lon2 = Number(pointB.longitude ?? pointB.lng ?? pointB.lon);

  if (
    !Number.isFinite(lat1) ||
    !Number.isFinite(lon1) ||
    !Number.isFinite(lat2) ||
    !Number.isFinite(lon2)
  ) {
    return Infinity;
  }

  const earthRadius = 6371000;
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) ** 2;

  return 2 * earthRadius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function isWithinRadius(pointA, pointB, radiusMeters) {
  return distanceInMeters(pointA, pointB) <= Number(radiusMeters || 0);
}

export default distanceInMeters;
